import React from 'react';
import { Switch } from 'antd';
import './style.scss';

export default function CustomSwitch(props) {
	return <Switch {...props}></Switch>;
}
